import styled from 'styled-components';
import { Button } from '@/components/UI/Button/Button';
import { CloseIcon, SearchIcon } from '@/components/UI/Icons/Icons';
import { InputBox } from '@/components/UI/Input/Input.styles';

export const SearchPanelFormWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const SearchPanelFormBox = styled.form.attrs({
  action: '/',
})`
  display: flex;
`;

export const SearchPanelFormContent = styled.div<{ $isFocused: boolean }>`
  display: flex;
  flex: 1 0;
  border-radius: 14px;
  border: 1px solid
    ${({ theme, $isFocused }) =>
      $isFocused ? theme.palette.brand.main : theme.palette.secondary.border};

  @media (min-width: 950px) {
    border-radius: 14px 0 0 14px;
    border-right: 0;
    background-color: ${({ theme }) => theme.palette.primary.background};
    z-index: ${({ $isFocused }) => ($isFocused ? 11 : 'auto')};
  }
`;

export const SearchPanelBtn = styled(Button).attrs({
  type: 'button',
  appearance: 'transparent',
  hasPadding: false,
})`
  height: 42px;
  padding: 14.5px 7.5px 13.5px 16.5px;

  @media (min-width: 950px) {
    height: 44px;
    cursor: default;
  }
`;

export const SearchPanelBtnIcon = styled(SearchIcon).attrs(({ theme }) => ({
  width: 16,
  height: 16,
  fill: theme.palette.secondary.labels,
}))``;

export const SearchPanelInput = styled(InputBox).attrs({
  id: 'q_keywords',
  type: 'search',
  autoCorrect: 'off',
  autoCapitalize: 'none',
  autoComplete: 'off',
  spellCheck: 'false',
  $hasBorderBottom: false,
  className: 'top-search__form-input',
})`
  padding: 0;

  @media (min-width: 950px) {
    border: 0;
    font-family: Arial;

    &::placeholder {
      font-size: 14px;
    }
  }
`;

export const SearchPanelClearBtn = styled(Button).attrs({
  appearance: 'transparent',
  hasPadding: false,
})`
  margin-right: 13.5px;
`;

export const SearchPanelClearBtnIcon = styled(CloseIcon).attrs(({ theme }) => ({
  width: 12.75,
  fill: theme.palette.secondary.labels,
}))``;

export const DesktopSearchPanelBtn = styled(Button).attrs({
  type: 'submit',
  appearance: 'primary',
  hasPadding: false,
  isBodyFontFamily: true,
})<{ $isFormFocused: boolean }>`
  min-width: 65.82px;
  padding: 0 15px;
  border-radius: 0 14px 14px 0;
  z-index: ${({ $isFormFocused }) => ($isFormFocused ? 11 : 'auto')};

  &:hover {
    background-color: ${({ theme }) => theme.palette.brand.mainOnHover};
  }
`;
